import React from 'react';
import { FaEnvelope, FaPhoneAlt, FaMapMarkerAlt } from 'react-icons/fa';
import './Contact.css';

const Contact = () => {
  return (
    <div className="contact-page">
      <div className="contact-page-header">
        <div className="contact-container">
          <h1 className="contact-page-title"><FaEnvelope /> Contact Us</h1>
          <p className="contact-page-subtitle">We are here to help you with any queries</p>
        </div>
      </div>

      {/* Map + Contact Info — horizontal row */}
      <div className="contact-container">
        <div className="contact-top-row">
          <div className="contact-map-wrapper contact-card">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3848.423321528659!2d78.03541631484462!3d15.76185898907315!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bb5e4682496739d%3A0xe67f920f2694f38e!2sIndian%20Institute%20of%20Information%20Technology%20Design%20and%20Manufacturing%20Kurnool!5e0!3m2!1sen!2sin!4v1646294567890!5m2!1sen!2sin"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              title="Google Maps"
            ></iframe>
          </div>

          <div className="contact-info-card-container">
            <div className="contact-info-item-card">
              <div className="contact-info-icon-box"><FaEnvelope /></div>
              <div className="contact-info-details">
                <h4 className="contact-info-title">Email</h4>
                <p className="contact-info-text">ncamst2026@iiitk.ac.in</p>
              </div>
            </div>

            <div className="contact-info-item-card">
              <div className="contact-info-icon-box"><FaPhoneAlt /></div>
              <div className="contact-info-details">
                <h4 className="contact-info-title">Phone</h4>
                <p className="contact-info-text">Dr. P V Prakash Madduri: 08518-289122</p>
                <p className="contact-info-text">Dr. P. Kishore: kishore@iiitk.ac.in / 08518-289240</p>
              </div>
            </div>

            <div className="contact-info-item-card">
              <div className="contact-info-icon-box"><FaMapMarkerAlt /></div>
              <div className="contact-info-details">
                <h4 className="contact-info-title">Address</h4>
                <p className="contact-info-text">Department of Sciences</p>
                <p className="contact-info-text">IIITDM Kurnool, Jagannathagattu Hill</p>
                <p className="contact-info-text">Kurnool, Andhra Pradesh-518008, India</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* How to Reach — vertically stacked below */}
      <div className="contact-container">
        <div className="contact-reach-section contact-card">
          <h2 className="contact-reach-title">How to Reach</h2>
          <p className="contact-reach-text">
            The IIITDM Kurnool campus is situated on a hilltop (Jaganathagattu Hill) near the Rupala Sangameswara Swamy Temple (an ancient, relocated Lord Shiva temple dating back to the 7th-8th century CE), located in Dinnedevarapadu Village, Kurnool.
          </p>
          <p className="contact-reach-text">
            It is approximately 12 km from the Kurnool City Railway Station and Bus Stand, and about 20-22 km from the Kurnool Airport (Orvakal). It is easily accessible via auto-rickshaw from the city, with a typical auto fare of around ₹300.
          </p>
          <p className="contact-reach-text">
            <strong>Landmarks:</strong> Key landmarks from Kurnool City Railway Station and Bus Stand include C-Camp, G. Pulla Reddy Engineering College (approx. 3 km away from IIITDM Kurnool), large Nandi idol, and Rupala Sangameswara Swamy Temple.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Contact;
